import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import {Update} from "@ngrx/entity";
import {AddressesActions} from "./addresses.actions";

export interface AddressesState {}

const initialState: any = {
  selectedId: undefined,
  query: undefined,
  resolveType: undefined
}

const reducer = createReducer(
  initialState,

  on(AddressesActions.setAddressId, (state, updatedState) => ({
    ...state,
    selectedId: updatedState.id,
    query: updatedState.query,
    resolveType: updatedState.resolveType
  }))

);

export const addressFeature = createFeature({
  name: 'Address',
  reducer,
});

export const selectAddress = (state: any) => state.Address;

export const selectAddressId = createSelector(
  selectAddress,
  (state: any) => {
    return {
      id: state.selectedId,
      query: state.query,
      resolveType: state.resolveType
    };
  }
);
